// AppShell = sidebar (esq) + header (top) + main (resto). Renderiza <Outlet />
// — filhos do route '/' caem aqui.
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppDispatch } from '@/app/store/hooks';
import { useUnreadSummaryQuery } from '@/features/inbox';
import { unreadSeeded } from '@/features/notifications';
import { useIsMobile } from '@/lib/hooks/useMediaQuery';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { BottomNav, useBottomNavVisible } from './BottomNav';
import { TabTitleManager } from './TabTitleManager';
import styles from './AppShell.module.css';

export function AppShell() {
  // Hidrata o badge de não-lidas no boot (mesmo abrindo fora do inbox). Só monta
  // autenticado (rota atrás de RequireAuth). O WS mantém ao vivo depois.
  const dispatch = useAppDispatch();
  const { data: unread } = useUnreadSummaryQuery();
  useEffect(() => {
    if (unread) dispatch(unreadSeeded(unread));
  }, [unread, dispatch]);

  // Mobile troca a Sidebar pela BottomNav (nunca ambas). O padding inferior do
  // .main só entra quando a nav está de fato visível (não na thread) — data-attr
  // é o contrato com o CSS.
  const isMobile = useIsMobile();
  const bottomNavVisible = useBottomNavVisible();

  return (
    <div className={styles.shell} data-bottomnav={bottomNavVisible || undefined}>
      <TabTitleManager />
      {!isMobile && <Sidebar />}
      <div className={styles.body}>
        <Header />
        <main className={styles.main} id="main">
          <Outlet />
        </main>
      </div>
      {isMobile && <BottomNav />}
    </div>
  );
}
